module.exports = __webpack_public_path__ + "assets/filter_bicycle-aedae1.svg";